import React from 'react';
import './Pricing.css';

const Pricing = (props) => {
  return (
    <div class="pricing-container">
      {/*
      <svg id='wave' viewBox="0 0 500 500" preserveAspectRatio="xMinYMin meet">
        <path id='wave-path' d="M0,100 C150,200 350,0 500,100 L500,00 L0,0 Z"></path>
      </svg>
      */}
      <div class='pricing-title-container'>
        <span class='pricing-title'>
          Pricing
        </span>
      </div>
      <div class='pricing-amt'>
        <div class='pricing-discounted-amt-container'>
          <span class='pricing-discounted-amt'>
            <sup>₹ </sup>199
          </span>
        </div>
        <div class='pricing-actual-amt-container'>
          <span class='pricing-actual-amt'>
          <strike>
            ₹ 299
          </strike>
          </span>
        </div>
      </div>
      <div class='pricing-buy-btn-container'>
        <button class='pricing-btn-container'>
          <span class='pricing-btn-text'>
            {props.isLoggedIn && 'Buy Now'}
            {!props.isLoggedIn && 'Login'}
          </span>
        </button>
      </div>
    </div>
  )
}
export default Pricing;
